const getCustomBlindsUrl = ({
  canonicalUrl,
  isBuildAndBuyProduct,
  blindsHost
}) => {
  if (!isBuildAndBuyProduct) {
    return canonicalUrl;
  }
  const regex = /\/p\//gi;
  const customBlindsPath = '/p/custom-blinds/';
  const customProductUrl = canonicalUrl && canonicalUrl.replace(regex, customBlindsPath);
  return `${blindsHost}${customProductUrl}`;
};

export const getCustomUrlWithAnalytics = ({
  canonicalUrl,
  isBuildAndBuyProduct,
  blindsHost,
  sponsoredValues
}) => {
  let productURL = getCustomBlindsUrl({ canonicalUrl,
    isBuildAndBuyProduct,
    blindsHost });
  // add sponsored tracking info in productURL
  if (!!sponsoredValues?.isSponsored && !!sponsoredValues?.sponsoredMetadata) {
    const campaignId = sponsoredValues?.sponsoredMetadata?.campaignId || '';
    const placementId = sponsoredValues?.sponsoredMetadata?.placementId || '';
    const slotId = sponsoredValues?.sponsoredMetadata?.slotId || '';

    productURL += (productURL.indexOf('?') > -1) ? '&' : '?';
    productURL += `ITC=AUC-${campaignId}-${placementId}-${slotId}`;
  }
  return productURL;
};
